import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { AssetTableRowData } from "../types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { Emdash } from "~/components/Punctuation/Emdash";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const APY_30_DAY_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.apy30Day,
    label: "30D APY",
    tooltip: CatalogMetricSlugs.apy_30_day,
    type: ColumnTypes.percent,
    sortsOn: AssetColumns.apy30Day,
    width: 125,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        if (!item.isAsset) {
            return <Emdash />;
        }

        const measure = getMeasureValue(item, "apy_30_day");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val / 100}
                pct_change_interval="30d"
                pct_change_value={measure.chg_30d_pct}
                type="percent"
            />
        );
    },
};
